import { Component, OnInit, OnDestroy } from '@angular/core';
import { BOARD_GAME_SETTINGS } from './board-game.settings';
import { RoomService } from '../../../shared/services/room.service';
import { Log } from '../../../shared/components/log/models/log.model';
import { MARVEL_CITATIONS } from './marvel-citations.model';
import { Router } from '@angular/router';
import { HubService } from '../../../shared/services/hub.service';
import { AngularFireDatabase } from '@angular/fire/database';
import { UserService } from '../../../shared/services/user.service';
import { StringUtils } from '../../../shared/utils/string.utils';
import { PlayerService } from '../../../shared/services/player.service';

@Component({
  selector: 'app-board-game',
  templateUrl: './board-game.component.html',
  styleUrls: ['./board-game.component.scss']
})
export class BoardGameComponent implements OnInit, OnDestroy {
  sharedUrl: string;

  welcomeModal = {
    open: true,
    title: 'Welcome in Marvel Champions Game',
    text: {
      heading: 'Be Legendary',
      content: [
        `
        You are playing a tabletop simulator.
        Face off in heroic combat in solo or cooperation mode. Make your move, but be prepare to react, because your opponent has a plan of their own. It all comes down to this—can you outwit them and win?
      `
      ]
    },
    citation:
      MARVEL_CITATIONS[Math.floor(Math.random() * MARVEL_CITATIONS.length)]
  };

  get logs(): Log[] {
    return this.roomService.logs;
  }
  set logs(logs: Log[]) {
    this.roomService.logs = logs;
  }

  get openLogs(): boolean {
    return this.roomService.openLogs;
  }
  set openLogs(openLogs: boolean) {
    this.roomService.openLogs = openLogs;
  }

  boardGameSettings = BOARD_GAME_SETTINGS;
  openEndGameModal = {
    display: false,
    label: null
  };

  roomRefSubscription;

  constructor(
    private router: Router,
    private roomService: RoomService,
    private hubService: HubService,
    private afd: AngularFireDatabase,
    private userService: UserService,
    private playerService: PlayerService
  ) {
    // TODO fix it: receive too much data takeLast not working, the data is empty
    setTimeout(() => {
      const hubId = StringUtils.getAllAfterLastChar(window.location.href, '/');
      const roomRef = this.afd.list(`hub/${hubId}`);
      this.roomRefSubscription = roomRef
        .snapshotChanges()
        .map(changes => {
          return changes.map(c => ({ [c.payload.key]: c.payload.val() }));
        })
        // .pipe(takeLast(1))
        .subscribe(res => {
          //WARNING res =
          res.reduce((r, c) => Object.assign(r, c), {});
          if (res['tabKey'] === 'gamewin' || res['tabKey'] === 'gameloose') {
            this.openEndGameModal = {
              display: true,
              label: res['tabKey'] === 'gamewin' ? 'YOU WIN!' : 'YOU LOOSE!'
            };

            // increment game counter if last game was > 5 min
            this.playerService.incrementPlayerNbGames(hubId);
            this.roomRefSubscription.unsubscribe();
          }
        });
    }, 2500);
  }

  ngOnInit() {
    this.sharedUrl = window.location.href;
  }

  ngOnDestroy() {
    this.roomRefSubscription.unsubscribe();
  }

  gameEnded(gameEndedValue: 'win' | 'loose'): void {
    // console.log(this.userService.userRestrictions().joinGameAsPlayer);
    if (this.userService.userRestrictions().joinGameAsPlayer) {
      this.hubService.updateHubPart(
        this.roomService.roomId,
        'tabKey',
        'game' + gameEndedValue
      );
    } else {
      console.warn('gameEnded: forbidden');
    }
  }

  confirmEndGame() {
    this.router.navigate(['/mc/progression']);
  }

  // if you are not the owner and game finished, open a modal saying game ended
}
